export enum MigrationFlow {
  Template = 'template',
  ADI = 'adi',
  Editor = 'editor',
  Editor2Fix = 'editor2Fix',
  Editor2Anchors = 'editor2Anchors',
  HeavySite = 'heavySite',
}
